


















































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import appconst from '@/lib/appconst'
    import createdata from '@/store/entities/create-stockorder'
    import CreateOrderProductInfo from '@/store/entities/create-stockorder-product'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import warehouseCity from '@/store/entities/warehouse-city'
    import warehouseInfo from '@/store/entities/warehouseInfo'
    import Enums from '@/lib/enums'

    @Component({
        name: "createstockorder",
    })
    export default class CreateOrder extends AbpBase {
        createrequest: createdata = new createdata();
        warehouseCityList: Array<warehouseCity> = [];
        storeaddressList: Array<storeaddressInfo> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        warehouseCityId: number = 0;
        addLoding = false;
        cargoCategoryType = Enums.CargoCategoryType;
        PlatformType = Enums.PlatformType;
        siteType = Enums.SiteSType;
        pdfInfo: string = '';
        pdfUrl: string = '';
        isShow: boolean ;
        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };
        ruleInline = {
            storeId: [
                { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
            ],
            orderNumber: [
                { required: true, min: 6, max: 200, message: '平台订单编号不能为空，且长度必须大于6且小于200', trigger: 'blur' }
            ],
            //shippingMethods: [
            //    { max: 100, message: '长度不能大于100', trigger: 'blur' }
            //],
            reMark: [
                { max: 500, message: '长度不能大于500', trigger: 'blur' }
            ]
        };

        async changedata(val: number) {
            var _this = this;
            this.storeaddressList.filter(function (item) {
                if (item.id == val) {
                    if (item.whetherLocal) {
                        _this.isShow = false;
                    }
                    else {
                        _this.isShow = true;
                    }
                }
            });
        }


        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            //var a = new storeaddressInfo();
            //a.id = null;
            //a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            //this.createrequest.storeId = this.storeaddressList[0].id;
            //this.storeaddressList.push(a);
        }
        handleSuccess(res, file) {
            if (res.success) {
                this.createrequest.pdfGuid = res.result;
                this.pdfInfo = "双击查看";
            }
        }

        async ViewPdf() {
            if (this.createrequest.pdfGuid && this.createrequest.pdfGuid.length > 0) {
                window.open(appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + this.createrequest.pdfGuid + "&id=" + abp.session.userId);
            }
        }

        handleError(res, file) {
            this.$Message.error('上传PDF失败。');
        }

        async created() {
            this.getData();
            this.pdfInfo = this.createrequest.pdfGuid ? "双击查看" : "未上传";
            this.pdfUrl = appconst.remoteServiceBaseUrl + "api/services/app/FrontOrder/UploadOrderPdf";

        }
        async add() {
            (this.$refs.createform as any).validate(async (valid: boolean) => {
                if (valid) {
                    if (!this.createrequest.pdfGuid || this.createrequest.pdfGuid.length < 1) {
                        this.$Message.error('请上传pdf。');
                        return;
                    }
                  
                    if (this.createrequest.orderProductInfosList.length == 0) {
                        this.$Message.error('请添加商品。');
                        return;
                    }
                   

                    this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'frontstockorder/createOrder',
                        data: this.createrequest
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.createform as any).resetFields();
                    this.$emit('save-success');

                    this.$router.push({ name: 'frontstockorder' });
                }
            })
        }
        productAdd() {
            this.createrequest.orderProductInfosList.push(new CreateOrderProductInfo());
        }
        productRemove(index) {
            this.createrequest.orderProductInfosList.splice(index, 1);
        }

        //isEmpty(rule, value, callback) {
        //    if (value == null || value == undefined || value == "") {
        //        callback(new Error('价格不能为空！'))
        //    } else {
        //        callback();
        //    }
        //}
    }
